module.exports = __webpack_public_path__ + "img/BarbieArm.c4c15bf5.png";